import React from "react";
import PropTypes from "prop-types";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";

import { RatingWrapper, Container, Reviews } from "./style";

const Rating = (props) => {
	const { ratings } = props;
	return (
		<RatingWrapper>
			{ratings.map((rating, index) => (
				<Container key={index}>
					<CloudinaryImage
						url={rating.logo.image}
						lazyload
						sizes={{
							default: { height: 50 },
						}}
					/>
					<Reviews>
						<a href={rating.ratingURL.link} target={rating.ratingURL.target}>
							{rating.rating}/5
							<div className="ratings">({rating.reviewCount} reviews)</div>
						</a>
					</Reviews>
				</Container>
			))}
		</RatingWrapper>
	);
};

Rating.propTypes = {
	ratings: PropTypes.array,
};

Rating.defaultProps = {
	ratings: [],
};

export default Rating;
